import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createWatchlist,
  deleteWatchlist,
  deleteWatchlistCoin,
  getWatchlist,
  getWatchlists,
} from "../../../services/WatchListServices/WatchListServices";

export const initialState = {
  loading: false,
  user_watchlists: [],
  watchlist_details: {},
  status: 0,
  message: "",
};

export const getUserWatchlists = createAsyncThunk(
  "watchlists/getUserWatchlists",
  async () => {
    try {
      const { data } = await getWatchlists();
      return data;
    } catch (ex) {
      console.log(ex);
    }
  }
);

export const getWatchListDetailsById = createAsyncThunk(
  "watchlists/getWatchListDetailsById",
  async (title) => {
    try {
      const { data } = await getWatchlist(title);
      return data;
    } catch (ex) {
      console.log(ex);
    }
  }
);

export const deleteUserWatchlist = createAsyncThunk(
  "watchlists/deleteUserWatchlist",
  async (title) => {
    try {
      const { status } = await deleteWatchlist(title);
      if (status >= 200) {
        
        window.location.reload();
      }
    } catch (ex) {
      console.log(ex);
    }
  }
);

export const removeCoinFromWatchlist = createAsyncThunk(
  "watchlists/removeCoinFromWatchlist",
  async ({ title, coinKey }) => {
    try {
      const { status } = await deleteWatchlistCoin(title, coinKey);
      if (status >= 200) {
        window.location.reload();
      }
    } catch (ex) {
      console.log(ex);
    }
  }
);

export const createNewWatchlist = createAsyncThunk(
  "watchlists/createNewWatchlist",
  async (title) => {
    try {
      console.log(title);
      const { status, data } = await createWatchlist(title);
      return [status, data];
    } catch (ex) {
      console.log(ex);
    }
  }
);

export const watchlistSlice = createSlice({
  name: "watchlists",
  initialState,
  reducers: {
    upsertUserWatchlist: (state, { payload }) => {
      const nextWatchlist = payload && typeof payload === "object" ? payload : null;
      if (!nextWatchlist) return;

      const currentPayload =
        state.user_watchlists && typeof state.user_watchlists === "object"
          ? state.user_watchlists
          : {};

      const currentResults = Array.isArray(currentPayload.results)
        ? currentPayload.results
        : [];

      const nextId = nextWatchlist?.id ?? nextWatchlist?._id;
      const nextResults = currentResults.filter((item) => {
        const currentId = item?.id ?? item?._id;
        if (nextId == null || currentId == null) return true;
        return currentId !== nextId;
      });

      state.user_watchlists = {
        ...currentPayload,
        results: [nextWatchlist, ...nextResults],
        count:
          typeof currentPayload.count === "number"
            ? Math.max(currentPayload.count, nextResults.length + 1)
            : nextResults.length + 1,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserWatchlists.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserWatchlists.fulfilled, (state, { payload }) => {
        state.user_watchlists = payload;
        state.loading = false;
      });
    builder
      .addCase(createNewWatchlist.pending, (state) => {
        state.loading = true;
      })
      .addCase(createNewWatchlist.fulfilled, (state, { payload }) => {
        console.log(payload);
        state.status = payload[0];
        state.loading = false;
      })
      .addCase(getWatchListDetailsById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWatchListDetailsById.fulfilled, (state, { payload }) => {
        state.watchlist_details = payload;
        state.loading = false;
      });
  },
});

export const { upsertUserWatchlist } = watchlistSlice.actions;

export default watchlistSlice.reducer;
